import { render, staticRenderFns } from "./mktCheckbox.vue?vue&type=template&id=2f7f867f&"
import script from "./mktCheckbox.vue?vue&type=script&lang=js&"
export * from "./mktCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./mktCheckbox.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports